module.exports = __webpack_public_path__ + "img/_icon_config.a4301cf8.svg";